import * as React from 'react';

import { doRule } from '../../api/rule';
import { useUserContext } from '../../context/UserStore';
import { TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

// Floating Do button with pastel rainbow gradient
const FloatingDoButton = styled(Button)(({ theme }) => ({
  border: '20px ridge black',
  background: 'linear-gradient(-45deg, #ffcccb, #add8e6, #90ee90, #f0e68c, #dda0dd, #ffd1dc, #98fb98, #b19cd9)',
  backgroundSize: '400% 400%',
  animation: 'floatPastelRainbow 4s ease infinite, pastelRainbow 3s ease infinite',
  color: '#333',
  fontWeight: 'bold',
  textShadow: '1px 1px 2px rgba(255,255,255,0.5)',
  
  '@keyframes floatPastelRainbow': {
    '0%': {
      transform: 'translateY(0px)',
    },
    '50%': {
      transform: 'translateY(-15px)',
    },
    '100%': {
      transform: 'translateY(0px)',
    }
  },
  
  '@keyframes pastelRainbow': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    }
  },
  
  '&:hover': {
    transform: 'scale(1.05) translateY(-5px)',
    boxShadow: '0 8px 25px rgba(0,0,0,0.2)',
  }
}));

// Fast rainbow gradient styled modal box
const RainbowModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  background: 'linear-gradient(-45deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4, #ffeaa7, #fab1a0, #fd79a8, #a29bfe)',
  backgroundSize: '400% 400%',
  animation: 'fastRainbow 4s ease infinite',
  border: '2px solid rgba(255, 255, 255, 0.3)',
  borderRadius: '12px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  padding: '2rem',
  backdropFilter: 'blur(10px)',
  
  '@keyframes fastRainbow': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    }
  },
  
  // Style text for better contrast
  '& .MuiTypography-root': {
    color: 'white',
    fontWeight: 'bold',
    textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
  },
  
  // Style text fields
  '& .MuiTextField-root': {
    margin: '10px 0',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '8px',
  }
}));

const style = {
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  position: 'absolute',
  p: 4,
};

export const Do = (props) => {
  const { id, overwritePoints,overwriteMargin } = props;
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [description, setDescription] = React.useState('');
  const [points, setPoints] = React.useState(overwritePoints);
    const [margin, setMargin] = React.useState(overwriteMargin);
  const { state: userState, action: userActions } = useUserContext();
  const handleChangeDescription = (event) => {
    setDescription(event.target.value);
  };
  const handleChangePoints = (event) => {
    setPoints(event.target.value);
  };
    const handleChangeMargin = (event) => {
    setMargin(event.target.value);
  };
  const handleSubmit = async () => {
    await doRule(id, description, points,margin);
    userActions.getUserEventsAsync();
    userActions.getUserDataAsyncAction();
    handleClose();
  };
  return (
    <>
      <div>
        <FloatingDoButton
          onClick={async () => {
            handleOpen();
          }}
        >
          Do
        </FloatingDoButton>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <RainbowModalBox>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Description
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Enter a description for the rule you're doing.
            </Typography>
            <TextField
              id="outlined-basic"
              label="Description"
              variant="outlined"
              onChange={handleChangeDescription}
              value={description}
              fullWidth
            />
            <TextField
              id="outlined-basic"
              label="Points"
              variant="outlined"
              onChange={handleChangePoints}
              value={points}
              fullWidth
            />
                        <TextField
              id="outlined-basic"
              label="Margin"
              variant="outlined"
              onChange={handleChangeMargin}
              value={margin}
              fullWidth
            />
            <Button 
              variant="contained" 
              onClick={handleSubmit}
              sx={{ 
                mt: 2,
                background: 'rgba(255, 255, 255, 0.9)',
                color: 'black',
                fontWeight: 'bold',
                '&:hover': {
                  background: 'rgba(255, 255, 255, 1)',
                }
              }}
            >
              Submit
            </Button>
          </RainbowModalBox>
        </Modal>
      </div>
    </>
  );
};
